import { render, staticRenderFns } from "./addEdit.vue?vue&type=template&id=062f5a7c&scoped=true"
import script from "./addEdit.vue?vue&type=script&lang=js"
export * from "./addEdit.vue?vue&type=script&lang=js"
import style0 from "./addEdit.vue?vue&type=style&index=0&id=062f5a7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062f5a7c",
  null
  
)

export default component.exports